// Phase 8 commerce UI dictionary (payment status). Code-only fixed wording; backend content stays in DB fields.
export const paymentDict: { en: Record<string, string>; ar: Record<string, string> } = {
  en: {
    "payment.confirmingTitle": "Confirming your payment...",
    "payment.confirmingBody": "Please wait while we process your order.",
    "payment.errorTitle": "Something went wrong",
    "payment.noSession": "No payment session found",
    "payment.verifyFailed": "Failed to verify payment",
    "payment.returnToCheckout": "Return to Checkout",
    "payment.contactSupport": "Contact Support",
    "payment.successTitle": "Payment Successful!",
    "payment.successBody": "Thank you for your order. We're crafting your personalized fragrance with care.",
    "payment.orderNumber": "Your Order Number",
    "payment.orderNumbers": "Your Order Numbers",
    "payment.confirmationEmailSent": "A confirmation email has been sent to your email address.",
    "payment.viewMyOrders": "View My Orders",
    "payment.continueShopping": "Continue Shopping",
    "payment.canceledTitle": "Payment Canceled",
    "payment.canceledBody": "Your payment was canceled. Don't worry - your cart items are still saved and you can complete your purchase whenever you're ready.",
    "payment.canceledHelp": "If you experienced any issues during checkout, please don't hesitate to contact our support team. We're here to help!",
    "payment.backToHome": "Back to Home",
  },
  ar: {
    "payment.confirmingTitle": "جارٍ تأكيد الدفع...",
    "payment.confirmingBody": "يرجى الانتظار بينما نعالج طلبك.",
    "payment.errorTitle": "حدث خطأ ما",
    "payment.noSession": "لم يتم العثور على جلسة دفع",
    "payment.verifyFailed": "تعذر التحقق من الدفع",
    "payment.returnToCheckout": "العودة إلى الدفع",
    "payment.contactSupport": "تواصل مع الدعم",
    "payment.successTitle": "تم الدفع بنجاح!",
    "payment.successBody": "شكرًا لطلبك. نحن نصنع عطرك المخصص بعناية.",
    "payment.orderNumber": "رقم طلبك",
    "payment.orderNumbers": "أرقام طلباتك",
    "payment.confirmationEmailSent": "تم إرسال رسالة تأكيد إلى بريدك الإلكتروني.",
    "payment.viewMyOrders": "عرض طلباتي",
    "payment.continueShopping": "متابعة التسوق",
    "payment.canceledTitle": "تم إلغاء الدفع",
    "payment.canceledBody": "تم إلغاء عملية الدفع. لا تقلق — منتجات سلتك لا تزال محفوظة ويمكنك إتمام الشراء متى شئت.",
    "payment.canceledHelp": "إذا واجهت أي مشكلة أثناء الدفع، لا تتردد في التواصل مع فريق الدعم. نحن هنا للمساعدة!",
    "payment.backToHome": "العودة إلى الرئيسية",
  },
};
